export function AmsRewardsCsvCtrl ( $uibModalInstance, $scope, $translate, $window, API, integrations, messages, workshopAPI) {

  $scope.start_date = '';
  $scope.end_date = '';
  $scope.integrations = integrations;

  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };

  $scope.send_csv_to_ams = function () {
    workshopAPI.get('/ams_rewards/send_csv', [$scope.start_date, $scope.end_date]).then(function () {
      messages.show($translate.instant('JS_SPACE.AMS_REWARDS.SENT_TO_AMS'), 'success');
      $uibModalInstance.close();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.download_csv = function () {
    $window.open(`${API.url}/ams-rewards/download_csv/${$scope.start_date}/${$scope.end_date}`);

    messages.show($translate.instant('JS_SPACE.AMS_REWARDS.DOWNLOADED_UPLOAD_TO_AMS'), 'success');

    $uibModalInstance.close();
  };
}
